import ReactSelect, { OptionProps, Props, StylesConfig, components } from 'react-select';
import { Box, Flex, Icon } from '@chakra-ui/react';
import { IconChevronDown, IconCheck } from '@tabler/icons-react';

const styles: (withError?: boolean) => StylesConfig = (withError) => ({
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  control: (provided) => ({
    ...provided,
    border: `1px solid ${withError ? 'red' : '#0d0d0d'}`,
    color: '#0d0d0d',
    borderRadius: '4px',
    boxShadow: 'unset',
    backgroundColor: 'white',
    fontWeight: 400,
    fontSize: '17px',
    ':hover': {
      borderColor: '#0d0d0d',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '12px 0px 12px 12px',
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#0d0d0d',
    margin: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    width: '72px',
    justifyContent: 'center',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '4px',
    border: '1px solid #0d0d0d',
    boxShadow: 'unset',
    zIndex: 5,
    marginTop: '4px',
    overflow: 'hidden',
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    '::-webkit-scrollbar': {
      display: 'none',
    },
  }),
  option: (provided, { isSelected }) => ({
    ...provided,
    color: 'inherit',
    backgroundColor: 'inherit',
    fontWeight: isSelected ? 600 : 400,
    fontSize: '17px',
    padding: '12px',
    paddingRight: isSelected ? '24px' : 'inherit',
    ':hover': {
      backgroundColor: '#e5e5e5',
    },
  }),
});

function DropdownIndicator() {
  return <Icon as={IconChevronDown} fontSize={24} />;
}
function IconOption(props: OptionProps) {
  const { label, isSelected } = props;
  return (
    <components.Option {...props}>
      <Flex direction="row" w="100%" align="center" justify="space-between" gap={2}>
        {label}
        {isSelected && (
          <Box boxSize="24px">
            <IconCheck />
          </Box>
        )}
      </Flex>
    </components.Option>
  );
}
const customComponents = {
  DropdownIndicator,
  Option: IconOption,
  IndicatorSeparator: () => null,
};

interface SelectProps extends Props {
  instanceId: string | number;
  withError?: boolean;
}

function SingleSelect(props: SelectProps) {
  const { withError } = props;

  return (
    <ReactSelect
      components={customComponents}
      styles={styles(withError)}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      {...props}
    />
  );
}

SingleSelect.defaultProps = {
  withError: false,
};

export default SingleSelect;
